module.exports = __webpack_public_path__ + "static/media/inter-medium.7a8cc724.woff";